export const locale = {
    lang: 'en',
    data: {
        MENU: {
            DASHBOARD: 'Dashboard',
            PRODUCTS: 'Products',
            PACKAGES: 'Packages',
            NETWORK: {
                COLLAPSIBLE: 'Network',
                MEMBERS: 'Members',
                MY_MEMBERS: 'Direct Referrals'
            },
            ORDERS: {
                COLLAPSIBLE: 'Orders',
                PRODUCTS: 'Products',
                PACKAGES: 'packages'
            },
            EARNING: {
                COLLAPSIBLE: 'Earning',
                PAIRING_BONUS: 'Pairing Bonus',
                SELF_REPURCHASE_BONUS: 'Self Repurchase Bonus',
                PERFORMANCE_BONUS: 'Performance Bonus',
                LEADERSHIP_BONUS: 'Leadership Bonus',
                DIRECTOR_BONUS: 'Director Bonus',
                CAR_FUND_BONUS: 'Car Fund Bonus',
                HOUSE_FUND_BONUS: 'House Fund Bonus',
                TOUR_FUND_BONUS: 'Tour Fund Bonus',
                CONSELING_BONUS: 'Conseling Bonus',
                PERFORMANCE_BONUS_OVERVIEW: 'Performance Bonus Overview'
            },
            SUPPORT_TICKETS: 'Support Tickets',
            ANNOUNCEMENT: 'announcement'
        }
    }
};
